///////////////////////////////////////////////////////////////////////
// HTTP Parameters: Voice Webhook
///////////////////////////////////////////////////////////////////////

export enum SoftDeviceWebhookAction {
  joinOngoingConference = 'joinOngoingConference',
  acceptCallListOffer = 'acceptCallListOffer',
}
